import type { UpdateActivity } from './typings'
import type { ActivityDetails } from '../../../typings'

export const updateActivityActionCreator = (
  payload?: ActivityDetails,
): UpdateActivity => ({
  type: 'activities/update',
  payload,
})
